/*
  «Выяснить у поставщика связи» - зависшие звонки и сообщения (05.10.2026, С-4).

  Звонок или сообщение, начатые и не завершённые: связь со станцией оборвалась
  посреди команды или сервер перезапустился посреди волны. Неизвестно, дошло ли
  до человека, и система сама не повторяет - второе обращение за сутки было бы
  нарушением частоты. Человек сверяется с журналом поставщика связи и нажимает
  одну из двух кнопок (решение владельца 05.10.2026).

  Вид - вариант Б макетов, выбранный владельцем: жёлтая плашка под шапкой
  раздела, список раскрывается по нажатию. Плашки нет, когда выяснять нечего:
  пустой блок на каждом заходе в раздел приучил бы его не замечать.
*/

import { Link } from 'react-router-dom'

import { contacts as contactsWord, dateTime } from '../api/format.js'
import { Notice } from './Common.jsx'
import PageBar from './PageBar.jsx'
import useStuckActions from './useStuckActions.js'

function ago(minutes) {
  if (minutes < 60) return `${minutes} мин назад`
  return `${Math.floor(minutes / 60)} ч ${minutes % 60} мин назад`
}

function markedText({ action, happened }) {
  // Подпись вида приходит с заглавной - для клетки и начала строки; посреди
  // фразы заглавная читалась бы началом нового предложения.
  const what = `${action.kind_title.toLowerCase()} по счёту ${action.account_number ?? '-'}`
  return happened
    ? `Отмечено: ${what} - состоялось.`
    : `Отмечено: ${what} - не состоялось, обратиться можно снова.`
}

function StuckRow({ action, busy, error, onMark }) {
  return (
    <div className="log__row">
      <span className="log__when">
        {dateTime(action.started_at)}
        <div className="muted">{ago(action.minutes)}</div>
      </span>
      {action.account_id ? (
        <Link to={`/accounts/${action.account_id}`}>
          {action.kind_title} по счёту {action.account_number}
        </Link>
      ) : (
        <span>{action.kind_title}</span>
      )}
      <span>
        {action.debtor_name ? <span>{action.debtor_name}</span> : null}
        {action.phone ? <span className="muted"> · {action.phone}</span> : null}
        {/* Строка кнопок - `log__states`, а не `.row`: у `.row` перенос выключен,
            и на телефоне вторая кнопка уехала бы за край плашки. */}
        <div className="log__states">
          <button type="button" className="button" disabled={busy} onClick={() => onMark(action, true)}>
            Состоялось
          </button>
          <button
            type="button"
            className="button button--quiet"
            disabled={busy}
            onClick={() => onMark(action, false)}
          >
            Не состоялось
          </button>
        </div>
        <Notice error={error} />
      </span>
    </div>
  )
}

export default function StuckActions() {
  // 21.10.2026: невыясненных обращений после больших волн бывают десятки - страницу режет
  // сервер, число `total` приходит с ней же.
  const { actions, total, bar, loadError, busyId, rowErrors, marked, mark } = useStuckActions()

  if (loadError) return <Notice error={loadError} wide />
  if (!actions) return null
  if (total === 0) {
    return marked ? <Notice kind="ok" wide>{markedText(marked)}</Notice> : null
  }

  const count = total
  return (
    <Notice kind="warn" wide>
      <div className="notice__what">
        {contactsWord(count)} неизвестно, {count === 1 ? 'состоялось' : 'состоялись'} ли.
      </div>
      <div className="notice__do">{actions[0].explanation}</div>
      {marked ? <div className="muted">{markedText(marked)}</div> : null}
      <details>
        <summary className="muted">Показать, что выяснить</summary>
        <div className="log">
          {actions.map((action) => (
            <StuckRow
              key={action.action_id}
              action={action}
              busy={busyId === action.action_id}
              error={rowErrors[action.action_id]}
              onMark={mark}
            />
          ))}
        </div>
        <PageBar {...bar} what="обращений" />
      </details>
    </Notice>
  )
}
